var Globalize, Jed, _, attributeGettext, flashTemplate, humanize, renderFlashes, renderNavbar, setLanguage, setupEvents, setupFormats, setupTranslations, sprintf, titleize;

if (global.jQuery == null) {
  global.jQuery = require('jquery');
}

require('bootstrap/js/alert');

_ = require('underscore');

humanize = require('underscore.string/humanize');

titleize = require('underscore.string/titleize');

flashTemplate = require('evesrp/templates/flash');

sprintf = (require('sprintf-js')).sprintf;

Jed = require('jed');

Globalize = require('globalize/dist/globalize-runtime');

require('globalize/dist/globalize-runtime/number');

require('globalize/dist/globalize-runtime/date');

setLanguage = function(ev) {
  var $form, $target;
  $target = jQuery(ev.target);
  $form = $target.closest('form');
  ($form.find('#lang')).val($target.data('lang'));
  $form.submit();
  return false;
};

renderFlashes = function(data) {
  var $content, flashInfo, i, len, ref, results;
  $content = jQuery('#content');
  ref = data.flashed_messages;
  results = [];
  for (i = 0, len = ref.length; i < len; i++) {
    flashInfo = ref[i];
    results.push((function(flashInfo) {
      var closeFunction, flash, flashID;
      flashID = _.uniqueId();
      flashInfo.id = flashID;
      flash = flashTemplate(flashInfo);
      $content.prepend(flash);
      closeFunction = function() {
        return (jQuery("#flash-" + flashID)).alert('close');
      };
      return window.setTimeout(closeFunction, 5000);
    })(flashInfo));
  }
  return results;
};

renderNavbar = function(data) {
  var $badge, badgeName, count, ref, results;
  ref = data.nav_counts;
  results = [];
  for (badgeName in ref) {
    count = ref[badgeName];
    $badge = jQuery("#badge-" + badgeName);
    results.push($badge.text((count !== 0 ? count : '')));
  }
  return results;
};

setupEvents = function() {
  (jQuery(document)).ajaxComplete(function(ev, jqxhr) {
    var data;
    data = jqxhr.responseJSON;
    if (data && 'flashed_messages' in data) {
      renderFlashes(data);
    }
    if (data && 'nav_counts' in data) {
      return renderNavbar(data);
    }
  });
  return (jQuery('.langSelect')).on('click', setLanguage);
};

module.i18nPromise = null;

setupTranslations = function() {
  var currentLang;
  if (module.i18nPromise != null) {
    return module.i18nPromise;
  }
  currentLang = document.documentElement.lang;
  module.i18nPromise = jQuery.Deferred();
  jQuery.ajax({
    type: 'GET',
    url: scriptRoot + "/static/translations/" + currentLang + ".json",
    success: function(data) {
      exports.i18n = new Jed({
        missing_key_callback: function(key, domain) {
          var errorMessage;
          errorMessage = sprintf("'%s' not found in domain '%s'", key, domain);
          console.log(errorMessage);
          if (typeof windowRaven !== "undefined" && windowRaven !== null) {
            return window.Raven.captureMessage(errorMessage, {
              level: 'warning',
              extra: {
                key: key,
                domain: domain,
                language: currentLang
              }
            });
          }
        },
        locale_data: data.locale_data,
        domain: data.domain
      });
      return module.i18nPromise.resolve();
    }
  });
  return module.i18nPromise;
};

module.globalizePromise = null;

setupFormats = function(locale) {
  if (locale == null) {
    locale = document.documentElement.lang;
  }
  if (module.globalizePromise != null) {
    return module.globalizePromise;
  }
  module.globalizePromise = jQuery.Deferred();
  if (locale === 'en-US') {
    locale = 'en';
  }
  Globalize = require("evesrp/globalize-" + locale);
  Globalize.locale(locale);
  exports.currencyFormat = Globalize.numberFormatter({
    style: 'decimal',
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
    round: 'truncate',
    useGrouping: true
  });
  exports.percentFormat = Globalize.numberFormatter({
    style: 'percent'
  });
  exports.numberFormat = Globalize.numberFormatter({
    style: 'decimal'
  });
  exports.dateFormatShort = Globalize.dateFormatter({
    datetime: 'short'
  });
  exports.dateFormatMedium = Globalize.dateFormatter({
    datetime: 'medium'
  });
  module.globalizePromise.resolve();
  return module.globalizePromise;
};

attributeGettext = function(attribute) {
  var humanizedAttribute, translatedAttribute;
  humanizedAttribute = humanize(attribute);
  translatedAttribute = exports.i18n.gettext(titleize(attribute));
  return translatedAttribute.toLowerCase();
};

exports.setupEvents = setupEvents;

exports.setupTranslations = setupTranslations;

exports.setupFormats = setupFormats;

exports.attributeGettext = attributeGettext;

//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
